import React, { useContext } from 'react'

const bookingContext = React.createContext()

const useBooking = () => {
    const context = useContext(bookingContext)
    if (!context) {
        throw new Error(`UseBooking must be used within an BookingProvider.`)
    }

    return context
}

const BookingProvider = ({ data, ...props }) => {
    return <bookingContext.Provider value={data} {...props} />
}

export { BookingProvider, useBooking }